import {
  CLIENT_ID,
  ACCESS_TOKEN,
  OUTLET_LIST,
  RESET_STATE,
  OUTLET_ID,
  ME_DETAILS,
  DINE_IN_ORDER_UPDATE,
} from "../action";

const initialState = {
  accessToken: null,
  clientId: null,
  storedOutlets: [],
  selectedOutletId: "",
  paymentSettingsFetched: false,
  savePaymentSettings: null

};

const storeReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ACCESS_TOKEN: {
      return {
        ...state,
        accessToken: action.payload,
      };
    }
    case CLIENT_ID: {
      return {
        ...state,
        clientId: action.payload,
      };
    }
    case OUTLET_LIST: {
      return {
        ...state,
        storedOutlets: action.payload
      }
    }
    case RESET_STATE: {
      return initialState;
    }
    case OUTLET_ID: {
      return {
        ...state,
        storeSelectedOutlet: action.payload
      }
    }
    case ME_DETAILS: {
      return {
        ...state,
        meDetails: action.payload
      }
    }
    case DINE_IN_ORDER_UPDATE: {
      return {
        ...state,
        dineInCartUpdate: action.payload
      }
    }
    case 'SET_PAYMENT_SETTINGS_FETCHED':
      return {
        ...state,
        paymentSettingsFetched: action.payload,
      };
    case 'SAVE_PAYMENT_SETTINGS':
      return {
        ...state,
        savePaymentSettings: action.payload,
      };

    default:
      return state;


  }


};

export default storeReducer;
